import { render } from "./Ricevute.vue?vue&type=template&id=3cc6ffa6"
import script from "./Ricevute.vue?vue&type=script&lang=js"
export * from "./Ricevute.vue?vue&type=script&lang=js"
script.render = render

export default script